import { render, staticRenderFns } from "./AprobarPlanIns.vue?vue&type=template&id=5a425c3f"
import script from "./AprobarPlanIns.vue?vue&type=script&lang=js"
export * from "./AprobarPlanIns.vue?vue&type=script&lang=js"
import style0 from "./AprobarPlanIns.vue?vue&type=style&index=0&id=5a425c3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports